import { Injectable } from '@angular/core';
import { decimalRegex, metaKeys, navigationKeys } from '../util';

@Injectable({
  providedIn: 'root'
})
export class AmountService {
  handleKeyDown(event: KeyboardEvent): void {
    const currentValue: string = (event.target as HTMLInputElement).value;
    const caretPos: number = (event.target as HTMLInputElement).selectionStart || 0;
    const pressedKey = event.key;

    const isDigitOrSeparator = /^\d$|[.,]$/.test(pressedKey);

    if ((event.metaKey || event.ctrlKey) && metaKeys.includes(pressedKey.toLowerCase())) {
      currentValue.slice(0, caretPos) + pressedKey + currentValue.slice(caretPos);
      return;
    }

    if (isDigitOrSeparator || (event.metaKey && metaKeys.includes(pressedKey.toLowerCase()))) {
      const updatedValue = currentValue.slice(0, caretPos) + pressedKey + currentValue.slice(caretPos);
      if (!decimalRegex.test(updatedValue)) {
        event.preventDefault();
      }
    } else if (!navigationKeys.includes(pressedKey)) {
      event.preventDefault();
    }
  }
}
